import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookingStateType, TicketInterface } from '@/Types/ticket.interface';

const initialState: BookingStateType = {
  loading: false,
  drawerOpen: false,
  error: null,
  activeTicket: null,
  allTickets: []
};

interface UpdateStatusPayload {
  field: keyof BookingStateType;
  value: boolean | null | TicketInterface | TicketInterface[];
}

const bookingSlice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    updateTicketState: (state, action: PayloadAction<UpdateStatusPayload>) => {
      const { field, value } = action.payload;
      (state[field] as typeof value) = value;
    },

    resetState: state => {
      state.drawerOpen = initialState.drawerOpen;
      state.activeTicket = initialState.activeTicket;
    }
  }
});

export const { updateTicketState, resetState } = bookingSlice.actions;

export default bookingSlice.reducer;
